import { render } from "./TaskViewDetalleTransferencia.vue?vue&type=template&id=702d032b&scoped=true"
import script from "./TaskViewDetalleTransferencia.vue?vue&type=script&lang=js"
export * from "./TaskViewDetalleTransferencia.vue?vue&type=script&lang=js"

import "./TaskViewDetalleTransferencia.vue?vue&type=style&index=0&id=702d032b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-702d032b"]])

export default __exports__